import { useState } from 'react';
import {
  Card,
  Button,
  Text,
  Spinner,
} from '@fluentui/react-components';
import { ArrowRightRegular } from '@fluentui/react-icons';
import { useAuth } from '@/auth/AuthContext';
import './Login.css';

export default function Login() {
  const { login } = useAuth();

  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleLogin = async () => {
    setError('');
    setIsLoading(true);
    try {
      await login();
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Sign-in failed. Please try again.');
      setIsLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-panel login-brand-panel">
        <div className="brand-content">
          <div className="brand-logo">𝚂</div>
          <h2 className="brand-title">Sherpai</h2>
          <p className="brand-tagline">Management Portal</p>
          <p className="brand-description">Manage all your tenants and track platform usage in one place.</p>
        </div>
      </div>

      <div className="login-panel login-form-panel">
        <Card className="login-card">
          <div className="login-header">
            <h1>Welcome Back</h1>
            <Text size={300} className="subtitle">
              Sign in to your account
            </Text>
          </div>

          {isLoading ? (
            <div className="login-loading">
              <Spinner size="large" />
              <Text>Redirecting to sign in...</Text>
            </div>
          ) : (
            <>
              <Button
                appearance="primary"
                onClick={handleLogin}
                style={{ width: '100%', marginTop: 'var(--space-md)' }}
                icon={<ArrowRightRegular />}
              >
                Sign in with Microsoft
              </Button>

              {error && (
                <div className="login-error">
                  <Text size={200}>{error}</Text>
                </div>
              )}

              <Text size={200} className="help-text">
                Sign in with your Component6 Microsoft account
              </Text>
            </>
          )}
        </Card>
      </div>
    </div>
  );
}
